import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "gpuinfo"
    }}>{`GPUInfo`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "clgpuinfolist"
    }}>{`clgpuInfoList`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`clgpuInfoList`}</strong>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/interfaces/opencldeviceinfo/"
      }}><em parentName="a">{`OpenCLDeviceInfo`}</em></a>{`[]`}</p>
    <hr></hr>
    <h3 {...{
      "id": "gpuinfolist"
    }}>{`gpuInfoList`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`gpuInfoList`}</strong>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/interfaces/opengldeviceinfo/"
      }}><em parentName="a">{`OpenGLDeviceInfo`}</em></a>{`[]`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      